module.exports = {
  password: {
    encrypt_split: '',  // 拼接字符串
    encrypt_type: 10, // 加密方式
    write_max: 16,  // 填写最大值
    write_min: 6  // 填写最小值
  }
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/password.js